<template>
  <div>
    <template>
      <v-card>
        <v-card-title>
          <span class='headline fontcolor'>{{ formTitle }}</span>
        </v-card-title>
        <v-card class='pl-7 pr-6 pt-5 pb-5'>
          <v-form ref='form' v-model='valid' lazy-validation>
            <v-row>
              <v-col>
                <v-text-field
                  v-model='editedItem.adoptionLabel'
                  :rules='adopLabelRules'
                  :maxlength=maxLength
                  hint='Please enter Adoption Label. Only letters(A-Z, a-z), numbers, space, period, hyphen and underscore is allowed. Max length 100 characters.'
                  label='Adoption Label*'
                  validate-on-blur
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model='editedItem.adoptionDescriptor'
                  :maxlength=maxLenDescriptor
                  :rules='[adoptionDescriptorRules]'
                  hint='Please enter the Adoption Label Descriptor. This will be displayed on the location profile pages.'
                  label='Adoption Label Descriptor'
                  validate-on-blur
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model='editedItem.abbreviation'
                  :maxlength=maxAbbrmLength
                  :rules='AbbreRules'
                  hint='Please enter Book Abbreviation. Only letters (A-Z, a-z) is allowed. Max length 10 characters.'
                  label='Book Abbreviation*'
                  validate-on-blur
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model='publisher'
                  :items='publisherList'
                  :item-text='concatPublisherNameAcr'
                  item-value='id'
                  :rules='publisherRules'
                  label='Publisher*'
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model='defaultStatus'
                  :items='defaultStatusItems'
                  label='Status*'
                  :rules='statusRules'
                ></v-select>
              </v-col>
            </v-row>
            <v-card-actions>
              <small color='primary'>*indicates required fields</small>
              <v-spacer></v-spacer>
              <v-btn outlined dark color='red' @click='closeDialog'>
                <v-icon dark>mdi-close</v-icon>Cancel
              </v-btn>
              <v-btn :loading='btnLoader' outlined class='fontcolor' @click='save'>
                <v-icon dark>mdi-check</v-icon>Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-card>
    </template>
 </div>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  data: () => ({
    valid: false,
    maxLenDescriptor: 255,
    maxLength: 100,
    maxAbbrmLength: 10,
    editedIndex: -1,
    formTitle: CONSTANTS.ADD_ADOPTION_LABEL,
    defaultStatus: CONSTANTS.DEFAULT_RECORDS_STATUS,
    statusValues: CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE,
    defaultStatusItems: CONSTANTS.RECORDS_STATUS,
    editedItem: {
      adoptionLabel: '',
      adoptionDescriptor: '',
      abbreviation: '',
      status: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: ''
    },
    defaultForm: {
      adoptionLabel: '',
      adoptionDescriptor: '',
      abbreviation: '',
      status: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: ''
    },
    btnLoader: false,
    adopLabelRules: [
      v => !!v || 'Adoption Label is required.',
      v =>
        /^[a-zA-Z0-9 ._-]+$/.test(v) ||
        'Invalid Input. Only characters (A-Z, a-z), number, space, period, hyphen, underscore is allowed!'
    ],
    AbbreRules: [
      v => !!v || 'Book Abbreviation is required.',
      v =>
        /^[a-zA-Z]+$/.test(v) ||
        'Invalid Input. Only characters (A-Z, a-z) is allowed!'
    ],
    statusRules: [v => !!v || 'Status is required.'],
    publisherRules: [v => !!v || 'Publisher is required.'],
    publisher: undefined,
    publisherList: []
  }),
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  mounted () {
    new Promise((resolve, reject, status = 2) => {
      this.$store.dispatch('PublisherModule/getPublisherList', {
        resolve,
        reject,
        status
      })
    })
      .then(responseData => {
        let cList = responseData.list
        if (Object.keys(cList).length !== 0) {
          let newCList = this.$globalStates.makeICCAsFirstItem(cList)
          this.publisherList = newCList
        } else {
          this.publisherList = cList
        }
      })
      .catch(({ response }) => {
      })
  },
  computed: {
  },
  methods: {
    closeDialog () {
      this.editedItem = Object.assign({}, this.defaultForm)
      this.editedIndex = -1
      this.btnLoader = false
      this.$refs.form.resetValidation()
      this.editedItem.status = CONSTANTS.DEFAULT_RECORDS_STATUS
      this.dialog = false
      this.$emit('resetDialog', this.dialog)
    },
    adoptionDescriptorRules (v) {
      if (v) {
        if (this.$globalFromValidation.IsContainOnlySpace(v)) {
          return 'Please enter valid input'
        } else {
          return true
        }
      } else {
        return true
      }
    },
    save () {
      if (this.$refs.form.validate()) {
        let statusField = 1
        this.defaultStatus !== undefined &&
        this.defaultStatus === 'Inactive' ? statusField = this.statusValues.Inactive : statusField = this.statusValues.Published
        this.btnLoader = true
        const formData = {
          adoptionLabel: this.editedItem.adoptionLabel,
          abbreviation: this.editedItem.abbreviation,
          adoptionDescriptor: this.editedItem.adoptionDescriptor,
          status: statusField,
          userId: this.userId,
          publisher: this.publisher
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionLabelModule/addAdoptionLabelItem', {
            resolve,
            reject,
            formData
          })
        })
          .then(responseData => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'green'
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(responseData.responseMessage)
            this.$globalStates.notification.init_notifications = true
            this.closeDialog()
          })
          .catch(response => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
            this.$globalStates.notification.init_notifications = true
          })
      }
    },
    concatPublisherNameAcr (item) {
      return item.name + ' (' + item.acronym + ')'
    }
  }
}
</script>
